import { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, Button, Badge } from '../../components/ui';
import { motion } from 'framer-motion';
import { usePremiumAccess } from '../../lib/usePremiumAccess';
import { Paywall } from '../../components/Paywall';

export function SubscriptionSection() {
  const [showPaywall, setShowPaywall] = useState(false);
  const { isPremiumActive, isSupportedPlatform, loading: premiumLoading, premiumStatus, refresh, shouldRequirePremium } = usePremiumAccess();

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.05 }}
        className="order-last"
      >
        <Card variant="elevated" padding="lg">
          <CardHeader>
            <div className="flex items-center justify-between gap-4">
              <div>
                <CardTitle>Subscription</CardTitle>
                <CardDescription>RevenueCat premium access for iOS bookings and client features</CardDescription>
              </div>
              <Badge variant={isPremiumActive ? 'success' : 'info'}>
                {premiumLoading ? 'Checking' : isPremiumActive ? 'Active' : shouldRequirePremium ? 'Locked' : 'Not Required'}
              </Badge>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-4 text-sm text-gray-600 dark:text-slate-400">
              <p>
                {isPremiumActive
                  ? `Premium is active${premiumStatus.expirationDate ? ` until ${new Date(premiumStatus.expirationDate).toLocaleDateString()}` : ''}.`
                  : shouldRequirePremium
                    ? 'Premium is required after onboarding to continue in the client app.'
                    : 'Premium access is enforced for onboarded users in the native iOS app.'}
              </p>
              {premiumStatus.productIdentifier && (
                <p className="text-xs uppercase tracking-wide text-gray-500 dark:text-slate-500">
                  Product: {premiumStatus.productIdentifier}
                </p>
              )}
              <div className="flex flex-col gap-2 sm:flex-row">
                {isSupportedPlatform && !isPremiumActive && shouldRequirePremium && (
                  <Button variant="primary" onClick={() => setShowPaywall(true)}>
                    View Plans
                  </Button>
                )}
                {isSupportedPlatform && (
                  <Button variant="outline" onClick={() => refresh()} disabled={premiumLoading}>
                    Refresh Status
                  </Button>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </motion.div>

      <Paywall
        isOpen={showPaywall}
        onClose={() => setShowPaywall(false)}
        onPurchased={async () => {
          await refresh()
          setShowPaywall(false)
        }}
      />
    </>
  );
}
